import React from 'react'
import Card from '../../components/Card/Card'
import { TiTickOutline } from 'react-icons/ti'
import { FiHelpCircle } from 'react-icons/fi';
import { TbMultiplier2X } from 'react-icons/tb';
import { FaTelegramPlane } from 'react-icons/fa';
import { AiFillLock, AiOutlineBulb } from 'react-icons/ai';
import './home.css'
import Faq from '../../components/Faq/Faq';
import Carousal from '../../components/Carousal/Carousal';
import { Link } from 'react-router-dom';
import bannerImg1 from '../../images/home-banner.webp'
import bannerImg2 from '../../images/taxi2.jpg'
import { motion } from 'framer-motion';
import Banner from '../../components/Banner/Banner';
import DownloadBanner from '../../components/DownloadBanner/DownloadBanner';
import RevolvingStrip from '../../components/RevolvingStrip/RevolvingStrip';

const SliderData = [
  {
      title: 'White cabs -  Leduc Taxi',
      desp: 'White cabs started 7 years ago as cooperative taxi. White Cabs is a 24/7 cooperative taxi company that prioritizes customer satisfaction.',
      image: bannerImg1,
      button: <Link to="https://whitecabs.webbooker.icabbi.com/"><button>BOOK NOW</button></Link>
  },
  {
    title: 'White cabs - Leduc Taxi',
    desp: ' Their fleet is safe, reliable, and well-maintained, and drivers undergo rigorous training to ensure a pleasant and trouble-free trip. ',
    image: "https://cdn.pixabay.com/photo/2023/03/16/13/09/taxi-7856666_960_720.jpg",
    button: <Link to="https://whitecabs.webbooker.icabbi.com/"><button>BOOK NOW</button></Link>
  },
  {
    title: 'White cabs -  Leduc Taxi',
    desp: 'They offer special vehicles for disabled individuals, an affordable parcel delivery service, and comply with strict standards of upkeep and cleanliness.',
    image: bannerImg2,
    button: <Link to="https://whitecabs.webbooker.icabbi.com/"><button>BOOK NOW</button></Link>
  }
]

const cards = [
  {
    icon: <TiTickOutline />,
    title: "Professional Drivers",
    des: "White Cabs offers reliable, professional service to and from the airport and beyond. Our experienced drivers know all the best routes in Leduc, ensuring a smooth journey every time."
  },
  {
    icon: <AiOutlineBulb />,
    title: "Cutting-Edge Technology",
    des: "Enjoy seamless booking through our advanced app, website, or automated phone system. Our dedicated call center and management team are also available for personalized assistance with your taxi service in Leduc."
  },
  {
    icon: <FiHelpCircle />,
    title: "Personalized Assistance",
    des: "Our friendly drivers are not just chauffeurs—they're guides! Discover Leduc's culture, history, and attractions with expert recommendations and attentive service."
  },
  {
    icon: <TbMultiplier2X />,
    title: "Diverse Services",
    des: "From local trips to special requests, our skilled drivers are equipped to handle every need. Experience unparalleled service with White Cabs' trusted flat-rate taxis in Leduc."
  },
  {
    icon: <FaTelegramPlane />,
    title: "Reliable Airport Service",
    des: "Available 24/7, our professional airport taxi service offers a range of vehicles tailored to your requirements. Schedule your pickup easily and enjoy a stress-free start to your journey."
  },
  {
    icon: <AiFillLock />,
    title: "Safe and Secure Rides",
    des: "Prioritizing safety and reliability, White Cabs is the trusted choice for personal and business travel. Our professional drivers guarantee a secure and comfortable experience."
  }
];


const faq = [
  {
    title: "Looking for a Leduc Taxi?",
    desc: "White Cabs provide flat-rate taxi services in Leduc. We provide quick and dependable service to our passengers because we know the value of time."
  },
  {
    title: "How do you get a taxi in Leduc?",
    desc: "To book a Leduc taxi, you can make your booking on our website, White Cabs, or give us a call."
  },
  {
    title: "How to hire a cab in Leduc?",
    desc: "Travelers can hire cabs in Leduc by visiting our website or calling our White Cabs services contact number."
  },
  {
    title: "Why customer trust WhiteCabs pricing?",
    desc: "The price from Leduc to Calgary Airport depends on the travel distance. We offer competitive pricing and flat-rate options for your convenience."
  },
  // {
  //   title: "What is taxi fare finder?",
  //   desc: "We understand passengers want transparent fare details. White Cabs offers flat-rate pricing based on local rates, ensuring affordability and reliability."
  // }
]

const Home = () => {
  
  return (
    <motion.div 
    initial={{opacity: 0}} animate={{opacity:1}} exit={{opacity:0}}
    className='home container'>
      <Banner
      bannerImg={bannerImg1}
        comp="home"
        title="Reliable Leduc Taxi Services – Book Your Ride Today!"
        description="Experience fast, comfortable, and affordable transportation with White Cabs Leduc. Our flat-rate pricing ensures no surprises—just dependable service to get you where you need to go on time. Book now for hassle-free travel!"
      />
      {/* <Carousal SliderData={SliderData} /> */}
      <DownloadBanner homeBanner='true' />
      <RevolvingStrip />
      <div className='home__services'>
        <h2 className='home__services_title'>Why choose White Cabs <br /> for Leduc Taxi Services?</h2>
        <div className="home__services_container">
          {cards.map((card, index) => (
            <Card key={index} card={card} />
          ))}
        </div>
      </div>
      <Faq title="Frequently Asked Questions" data={faq} />
    </motion.div>
  )
}


export default Home